import { Component, Input } from '@angular/core';

@Component({
  selector: 'project-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss']
})
export class ProjectFailedComponent {

  @Input() action: any;

  constructor() { }
}
